import { z } from 'zod';
import { NearbyPersonSchema } from './presence';
import { CircleMessageSchema } from './circle';

/**
 * WebSocket envelope for the `SpotRoom` Durable Object. The client connects with
 * `?token=<session>&spot=<id>` and thereafter exchanges these framed messages.
 */

/* ---- client → server ---- */
export const ClientWsMessageSchema = z.discriminatedUnion('t', [
  z.object({
    t: z.literal('presence'),
    coords: z.object({ lat: z.number(), lng: z.number(), heading: z.number().nullable() }),
    glowOn: z.boolean(),
    appearanceBlurb: z.string().max(80).optional(),
    section: z.string().max(24).optional(),
  }),
  z.object({ t: z.literal('circle_join'), roomId: z.string() }),
  z.object({ t: z.literal('circle_leave'), roomId: z.string() }),
  z.object({ t: z.literal('circle_say'), roomId: z.string(), text: z.string().max(300) }),
  z.object({ t: z.literal('ping') }),
]);
export type ClientWsMessage = z.infer<typeof ClientWsMessageSchema>;

/* ---- server → client ---- */
export const ServerWsMessageSchema = z.discriminatedUnion('t', [
  z.object({ t: z.literal('presence_list'), people: z.array(NearbyPersonSchema) }),
  z.object({ t: z.literal('circle_message'), roomId: z.string(), message: CircleMessageSchema }),
  z.object({
    t: z.literal('circle_history'),
    roomId: z.string(),
    messages: z.array(CircleMessageSchema),
  }),
  z.object({ t: z.literal('system'), text: z.string() }),
  z.object({
    t: z.literal('mod_event'),
    roomId: z.string().nullable(),
    text: z.string(),
  }),
  z.object({ t: z.literal('pong') }),
  z.object({ t: z.literal('error'), code: z.string(), message: z.string() }),
]);
export type ServerWsMessage = z.infer<typeof ServerWsMessageSchema>;
